import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from './error/error.component';
import { TimeoutComponent } from './timeout/timeout.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';
import { RouterModule } from '@angular/router';
import { resultRoutes } from './result.route';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NzStatisticModule } from 'ng-zorro-antd';
import { RedirectComponent } from './redirect/redirect.component';
import { PaymentThreedResultComponent } from './payment-threed-result/payment-threed-result.component';
import { SharedCommonModule } from '../../shared/shared-common.module';
import { LayoutModule } from '../../layout/layout.module';
import { TimeOutResolve } from '../../shared/resolvers/time-out-resolve';
import { ParentalLeaveNotOkComponent } from './parental-leave-not-ok/parental-leave-not-ok.component';


@NgModule({
  declarations: [ErrorComponent, TimeoutComponent, PaymentResultComponent, PageNotFoundComponent, RedirectComponent, PaymentThreedResultComponent,ParentalLeaveNotOkComponent],
    imports: [
        CommonModule,
        SharedCommonModule,
        RouterModule.forChild(resultRoutes),
        NzStatisticModule,
        LayoutModule,
    ],
  exports: [RedirectComponent],
  providers: [TimeOutResolve]
})
export class ResultModule {
}
